import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { useLingui } from "@lingui/react";

import { ReportsContextProvider } from "#app/providers/reports-context-provider";
import { getActiveStoreId } from "src/redux/selectors";
import { SidebarInset, SidebarProvider } from "src/@/components/ui/sidebar";
import { AppSidebar } from "#navigation/sidebar";
import { PubnubContextProvider } from "#app/providers/pubnub-context-provider";
import { NavigationHeader } from "#navigation/sidebar/navigation-header";
import { useCustomLayoutStyles } from "#app/providers/use-custom-layout-styles";
import { RouteProtection } from "#navigation/components/RouteProtection";
import { MenuServiceProvider } from "#menu/MenuServiceProvider";
import OnboardingProvider from "#onboarding/utils/OnboardingContext";

export const Layout = () => {
    const activeStoreId = useSelector(getActiveStoreId);
    const { layoutClassName } = useCustomLayoutStyles();
    const { i18n } = useLingui();

    // a few more providers. the rest are in global-providers.tsx
    return (
        <MenuServiceProvider>
            <OnboardingProvider>
                <PubnubContextProvider>
                    <RecoilRoot key={activeStoreId || "unknown"}>
                        <ReportsContextProvider>
                            <SidebarProvider>
                                <AppSidebar />
                                <SidebarInset>
                                    <NavigationHeader />
                                    <div
                                        key={i18n.locale}
                                        id="app-layout"
                                        className={layoutClassName}
                                    >
                                        <RouteProtection>
                                            <Outlet />
                                        </RouteProtection>
                                    </div>
                                </SidebarInset>
                            </SidebarProvider>
                        </ReportsContextProvider>
                    </RecoilRoot>
                </PubnubContextProvider>
            </OnboardingProvider>
        </MenuServiceProvider>
    );
};
